import React from "react";
import phaverImage from "../../assets/lensBanner.png";

const FinalDrop = ({ input1, input3, multiplier, onCheckAgain }) => {
  let ratio = 0;
  let lastAlloc = 0;
  
  ratio = [(input1 * multiplier) / input3];
  lastAlloc = 200000000 * ratio;

  console.log("Ratio:", ratio);
  console.log("Last Alloc:", lastAlloc);
  return (
    <div>
      <div>
        <img src={phaverImage} className="img-fluid mt-6 mb-2" alt="creator" />
      </div>
      <div className="alert alert-success mt-4" role="alert">
        <h1 className="alert-heading mb-4">Congratulations!</h1>
        <h4>Season 2 Airdrop: {Math.round(lastAlloc)} $SOCIAL</h4>
      </div>
      <button
        type="button"
        className="btn btn-warning"
        onClick={onCheckAgain} 
      >
        Check Again
      </button>
    </div>
  );
};

export default FinalDrop;
